export class PrivateLinkInstructionStep {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "stepNumber",
            "baseName": "stepNumber",
            "type": "number",
            "format": ""
        },
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "command",
            "baseName": "command",
            "type": "string",
            "format": ""
        },
        {
            "name": "downloadLink",
            "baseName": "downloadLink",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PrivateLinkInstructionStep.attributeTypeMap;
    }
    constructor() {
    }
}
